"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Dropdown = _interopRequireDefault(require("../Dropdown/Dropdown"));

var _PopupProvider = _interopRequireDefault(require("../Utility/PopupProvider"));

var _PopupProvider_placements = require("../Utility/PopupProvider_placements");

var _TriangleUpDownIcon = _interopRequireDefault(require("../Icons/TriangleUpDownIcon"));

var _Input = _interopRequireDefault(require("../Input/Input"));

var _InputWidthProvider = _interopRequireDefault(require("../Utility/InputWidthProvider"));

var _MagGlassIcon = _interopRequireDefault(require("../Icons/MagGlassIcon"));

var _SelectDropdown = _interopRequireDefault(require("./SelectDropdown"));

var _FlexLayout = _interopRequireDefault(require("../Layouts/FlexLayout"));

var _ThemeManager = _interopRequireDefault(require("../../../managers/ThemeManager"));

var _I18nManager = _interopRequireDefault(require("../../../managers/I18nManager"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

// Placements for PopupProvider.
var selectPlacements = {
  top: JSON.parse(JSON.stringify(_PopupProvider_placements.placementPositions.topLeft)),
  bottom: JSON.parse(JSON.stringify(_PopupProvider_placements.placementPositions.bottomLeft))
};

var searchIcon = _react.default.createElement(_MagGlassIcon.default, {
  key: "mag-icon",
  color: _ThemeManager.default.getVar('gray-1')
});

var InputAutoWidth = (0, _InputWidthProvider.default)(_Input.default);
/**
 * Select input component is for picking one item from a list of items on a drop down.
 *
 * @keywords DefaultSelect, SystemSelect, Select
 */

var Select =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Select, _React$Component);

  function Select(props) {
    var _this;

    _classCallCheck(this, Select);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Select).call(this, props));

    _this.handleOnInputClick = function (event) {
      var onClick = _this.props.inputProps.onClick;

      _this.setState({
        dropdownActive: true
      });

      if (onClick) {
        onClick(event);
      }
    };

    _this.handleOnPopupAlign = function (dom) {
      if (dom.className.includes('-placement-top')) {
        _this.setState({
          dropdownPlacement: 'top'
        });

        return;
      }

      _this.setState({
        dropdownPlacement: 'bottom'
      });
    };

    _this.handleOnSelectedChange = function (selectedRow) {
      var onSelectedChange = _this.props.onSelectedChange; // close the dropdown

      _this.setState({
        dropdownActive: false
      }); // Async because when dropdown is clicked a blur event is fired
      // on the `<input>` dom.  This will refocus on the input dom.


      setTimeout(function () {
        if (onSelectedChange) {
          onSelectedChange(selectedRow);
        }

        _this.inputRef.current.focus();
      }, 0);
    };

    _this.state = {
      dropdownActive: false,
      // See handleWindowResize
      dropdownWidth: 0,
      // See handleOnPopupAlign.  Use for styling the input and dropdown
      // properly based on the placement.
      dropdownPlacement: 'bottom'
    };
    _this.inputRef = _react.default.createRef();
    _this.InputComponent = _Input.default;

    if (props.autoSize) {
      // The input will get auto width resize.
      _this.InputComponent = InputAutoWidth;
    }

    return _this;
  }
  /**
   * @override
   */


  _createClass(Select, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      // if Input component size changes, we need to update the dropdown size
      var newWidth = this.inputRef.current.parentNode.clientWidth;

      if (newWidth !== this.state.dropdownWidth) {
        // eslint-disable-next-line react/no-did-update-set-state
        this.setState({
          dropdownWidth: this.inputRef.current.parentNode.clientWidth
        });
      }
    }
    /**
     * Handler for when input area is clicked.
     * @param {event} event - input dom event.
     */

  }, {
    key: "isInputSizeMatchDropdown",

    /**
     * True we use should match input size(width) with dropdown size.
     * @return {boolean} - true or false.
     */
    value: function isInputSizeMatchDropdown() {
      var _this$props = this.props,
          dropdownMatchSelectWidth = _this$props.dropdownMatchSelectWidth,
          autoSize = _this$props.autoSize;
      /**
       * If autoSize(input) is set to true then dropdown does not need to
       * match input size.
       */

      if (autoSize) {
        return false;
      }

      return dropdownMatchSelectWidth;
    }
  }, {
    key: "renderInput",
    value: function renderInput() {
      var _this$props2 = this.props,
          className = _this$props2.className,
          inputProps = _this$props2.inputProps,
          selectedRow = _this$props2.selectedRow,
          searchable = _this$props2.searchable,
          error = _this$props2.error,
          rowsData = _this$props2.rowsData,
          autoSize = _this$props2.autoSize,
          getPopupContainer = _this$props2.getPopupContainer,
          rowRenderer = _this$props2.rowRenderer,
          loading = _this$props2.loading,
          onSelectedChange = _this$props2.onSelectedChange,
          dropdownMatchSelectWidth = _this$props2.dropdownMatchSelectWidth,
          dropdownProps = _this$props2.dropdownProps,
          type = _this$props2.type,
          placeholder = _this$props2.placeholder,
          props = _objectWithoutProperties(_this$props2, ["className", "inputProps", "selectedRow", "searchable", "error", "rowsData", "autoSize", "getPopupContainer", "rowRenderer", "loading", "onSelectedChange", "dropdownMatchSelectWidth", "dropdownProps", "type", "placeholder"]);

      var _this$state = this.state,
          dropdownPlacement = _this$state.dropdownPlacement,
          dropdownActive = _this$state.dropdownActive;
      var InputComponent = this.InputComponent; // Set Select Icon

      var selectIconColor;

      if (inputProps && inputProps.disabled && type === 'mini') {
        selectIconColor = _ThemeManager.default.getVar('gray-3');
      } else {
        selectIconColor = _ThemeManager.default.getVar('gray-1');
      }

      var appearanceType = {};

      if (type === 'mini') {
        appearanceType = {
          appearance: 'inline'
        };
      }

      var mergedInputProps = _objectSpread({
        value: '',
        readOnly: true,
        placeholder: placeholder || _I18nManager.default.t('Select', 'please_select')
      }, appearanceType, {}, inputProps, {
        error: error
      });

      if (selectedRow) {
        mergedInputProps.value = selectedRow.label;
      }

      var mergedSuffix = [];

      if (inputProps.suffix) {
        mergedSuffix.push(inputProps.suffix);
      }

      if (searchable) {
        mergedInputProps.readOnly = false;
        mergedInputProps.placeholder = placeholder || _I18nManager.default.t('Select', 'search');

        if (dropdownActive) {
          // Display the search Icon and the search value.
          mergedInputProps.value = inputProps.value;
          mergedSuffix.push(searchIcon);
        } else {
          mergedSuffix.push(this.renderSelectIcon(selectIconColor));
        }
      } else {
        mergedSuffix.push(this.renderSelectIcon(selectIconColor));
      }

      mergedInputProps.suffix = _react.default.createElement(_FlexLayout.default, {
        className: "suffix-wrapper",
        alignItems: "center",
        itemSpacing: "10px"
      }, mergedSuffix);

      var clsPrfx = _ThemeManager.default.getVar('classPrefix');

      return _react.default.createElement("div", _extends({
        className: (0, _classnames.default)(className, "".concat(clsPrfx, "-select-input ").concat(clsPrfx)),
        "data-auto-size": autoSize,
        "data-disabled": inputProps.disabled,
        "data-dropdown-placement": dropdownActive ? dropdownPlacement : '',
        "data-type": type,
        "data-searchable": searchable
      }, props), _react.default.createElement(InputComponent, _extends({}, mergedInputProps, {
        wrapperProps: {
          onClick: mergedInputProps.disabled ? null : this.handleOnInputClick
        },
        inputRef: this.inputRef
      })));
    }
    /**
     * Render Select Icon
     * @param {string} color - color of select icon
     * @returns {ReactElement} of select icon
     */

  }, {
    key: "renderSelectIcon",
    value: function renderSelectIcon(color) {
      return _react.default.createElement(_TriangleUpDownIcon.default, {
        key: "triangle-icon",
        color: color
      });
    }
    /**
     * Render Select drop down border focus color
     * @returns {ReactElement} drop down border
     */

  }, {
    key: "renderDropDownBorder",
    value: function renderDropDownBorder() {
      return _react.default.createElement("div", {
        className: "short-border",
        style: {
          width: this.state.dropdownWidth
        }
      });
    }
  }, {
    key: "renderDropDown",
    value: function renderDropDown() {
      var _this$props3 = this.props,
          rowsData = _this$props3.rowsData,
          selectedRow = _this$props3.selectedRow,
          rowRenderer = _this$props3.rowRenderer,
          noDataMessage = _this$props3.noDataMessage,
          loadingMessage = _this$props3.loadingMessage,
          loading = _this$props3.loading,
          error = _this$props3.error,
          dropdownProps = _this$props3.dropdownProps,
          type = _this$props3.type;

      var selectDropdownProps = _objectSpread({
        rowsData: rowsData,
        loading: loading,
        selectedRow: selectedRow,
        rowRenderer: rowRenderer,
        noDataMessage: noDataMessage,
        loadingMessage: loadingMessage,
        type: type,
        'data-input-error': error
      }, dropdownProps, {
        onSelectedChange: this.handleOnSelectedChange
      });

      return _react.default.createElement("div", {
        "data-dropdown-match-width": this.isInputSizeMatchDropdown()
      }, _react.default.createElement(_SelectDropdown.default, selectDropdownProps), type === 'default' ? this.renderDropDownBorder() : null);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props4 = this.props,
          getPopupContainer = _this$props4.getPopupContainer,
          type = _this$props4.type,
          inputProps = _this$props4.inputProps; // if input is disabled, no need to show dropdown

      if (inputProps.disabled) {
        return this.renderInput();
      }

      var popupStyle = {};

      if (this.isInputSizeMatchDropdown()) {
        popupStyle.width = this.state.dropdownWidth;
      } else {
        popupStyle.minWidth = this.state.dropdownWidth;
      }

      if (type === 'mini') {
        return _react.default.createElement(_Dropdown.default, {
          popupClassName: "".concat(_ThemeManager.default.getVar('classPrefix'), "-select-popup"),
          action: "click",
          popup: this.renderDropDown(),
          popupOffset: {
            x: '15px'
          },
          popupPlacement: "bottomRight",
          popupVisible: this.state.dropdownActive,
          mask: true,
          maskClosable: true,
          onPopupVisibleChange: function onPopupVisibleChange(visible) {
            return _this2.setState({
              dropdownActive: visible
            });
          }
        }, this.renderInput());
      }

      return _react.default.createElement(_PopupProvider.default, {
        popupClassName: (0, _classnames.default)("".concat(_ThemeManager.default.getVar('classPrefix'), "-select-popup"), !this.isInputSizeMatchDropdown() ? '-extended' : null),
        popupStyle: popupStyle,
        action: "click",
        popup: this.renderDropDown(),
        popupVisible: this.state.dropdownActive,
        popupPlacement: "bottom",
        builtinPlacements: selectPlacements,
        getPopupContainer: getPopupContainer,
        onPopupAlign: this.handleOnPopupAlign,
        mask: true,
        maskClosable: true,
        onPopupVisibleChange: function onPopupVisibleChange(visible) {
          return _this2.setState({
            dropdownActive: visible
          });
        }
      }, this.renderInput());
    }
  }]);

  return Select;
}(_react.default.Component);

exports.default = Select;
Select.defaultProps = {
  searchable: false,
  inputProps: {},
  dropdownProps: {},
  dropdownMatchSelectWidth: true,
  error: false,
  type: 'default'
};
Select.propTypes = {
  /**
   * Custom class name.
   */
  className: _propTypes.default.string,

  /**
   * Array of rows.  Each row is a select option.
   */
  rowsData: _propTypes.default.arrayOf(_propTypes.default.shape({
    /**
     * Unique string/num identifier for this item.
     * Unless props.rowKeyAttribute defined a different string, 'key' is required.
     */
    key: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

    /**
     * When this item is selected this is the label used to display on
     * the top level selected items input.
     * This is also used to display in the drop down option.  If you need
     * to customize what to display for each row see props.rowRenderer
     */
    label: _propTypes.default.string.isRequired,

    /**
     * Optional properties to be added in to the row Dom.
     */
    rowProps: _propTypes.default.object
  })),

  /**
   * The row from rowsData that is currently be selected.  The shape of this
   * object is the same as an item in rowsData.
   */
  selectedRow: _propTypes.default.object,

  /**
   * By default the drop down options render each row with row.label.<br>
   * This callback allows you to customize your rendering of row data.<br>
   * rowRenderer(rowData, isSelected)<br>
   * @param {object} rowData: This is the data for the row to be rendered.<br>
   * @param {boolean} isSelected: true if it is marked as selected, false otherwise.<br>
   * @return {ReactNode} - The function should return a React node.<br>
   */
  rowRenderer: _propTypes.default.func,

  /**
   * The key attribute in a row item from rowsData[] to use as
   * a unique identifier.
   */
  rowKeyAttribute: _propTypes.default.string,

  /**
   * Callback function to handle the when a row is selected.
   * onSelectedChange(selectedRow)<br>
   * @param {object} selectedRow: one of the row in rowsData.
   */
  onSelectedChange: _propTypes.default.func,

  /**
   * Message to display when rowsData is empty.
   */
  noDataMessage: _propTypes.default.string,

  /**
   * To indicate that rowsData is being loaded.
   */
  loading: _propTypes.default.bool,

  /**
   * Customize the display string for when loading is set to true.
   */
  loadingMessage: _propTypes.default.string,

  /**
   * See [Input](#!/Input) component for all valid input attributes.
   */
  inputProps: _propTypes.default.object,

  /**
   * Props to pass to dropdown
   */
  dropdownProps: _propTypes.default.object,

  /**
   * Set to true to turn on searchable styling.
   */
  searchable: _propTypes.default.bool,

  /**
   * If set to false, this will allow dropdown to extend beyond the input width.
   * This will be ignored if autoSize is set to true.
   */
  dropdownMatchSelectWidth: _propTypes.default.bool,

  /**
   * True if the select input display should auto adjust size to fit the selected content.
   * Note: when this is set to true, dropdownMatchSelectWidth will be ignored.
   */
  autoSize: _propTypes.default.bool,

  /**
   * Styling to indicate error on the input.
   */
  error: _propTypes.default.bool,

  /**
   * Visual appearance of Select.
   */
  type: _propTypes.default.oneOf(['default', 'mini']),

  /**
   * Default placeholder text when a row hasn't been selected.
   */
  placeholder: _propTypes.default.string
};